export default __webpack_public_path__ + "static/media/au-the-ternary-novotel-sydney-darling-harbour.d4d7f23b.jpg";